import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  modalContainer: {
    background: theme.palette.background.paper,
    boxShadow: '0px 3px 6px #00000024',
    borderRadius: 4,
    overflow: 'auto',
    maxHeight: '100%',
  },
  modalBtn: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    letterSpacing: 0.7,
    marginLeft: 20,
  },
  modalHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
  },
  modalHeaderPadding: {
    padding: '30px 20px 15px 64px',
  },
  modalFooter: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0px 64px 20px 64px',
  },
  modalHeaderTitle: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(18),
    display: 'flex',
    alignItems: 'center',
  },
  modalBody: {
    padding: '0px 64px 20px',
  },
  modalsm: {
    maxWidth: 400,
    width: '100%',
  },
  modalmd: {
    maxWidth: 600,
    width: '100%',
  },
  modalxl: {
    maxWidth: 1046,
    width: '100%',
  },
  modallg: {
    width: '100%',
  },
  tooltipSize: {
    fontSize: theme.typography.pxToRem(14),
    marginLeft: '0.313rem',
  },
}));

export default useStyles;
